import React, { useCallback, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { makeStyles } from 'tss-react/mui';
import Icon from '../../../base/icons/components/Icon';
import { IconVolumeUp } from '../../../base/icons/svg';
import { inklusivaContextMenuStyles } from '../../../inklusiva/ui-constants';
import { VOLUME_SLIDER_SCALE } from '../../constants';
const useStyles = makeStyles()(theme => {
    return {
        ...inklusivaContextMenuStyles(theme)
    };
});
const _onClick = (e) => {
    e.stopPropagation();
};
const VolumeSlider = ({ initialValue, onChange, label }) => {
    const { classes, cx } = useStyles();
    const { t } = useTranslation();
    const [volumeLevel, setVolumeLevel] = useState((initialValue || 0) * VOLUME_SLIDER_SCALE);
    const _onVolumeChange = useCallback((event) => {
        const newVolumeLevel = Number(event.currentTarget.value);
        onChange(newVolumeLevel / VOLUME_SLIDER_SCALE);
        setVolumeLevel(newVolumeLevel);
    }, [onChange]);
    return (React.createElement("div", { "aria-label": t('volumeSlider'), className: classes.contextMenuSlider },
        React.createElement("label", { className: classes.contextMenuSliderLabel }, label),
        React.createElement("div", { className: cx('popupmenu__contents', classes.contextMenuSliderInner), onClick: _onClick },
            React.createElement("span", { className: classes.contextMenuSliderIcon },
                React.createElement(Icon, { size: 22, src: IconVolumeUp })),
            React.createElement("input", { "aria-valuemax": VOLUME_SLIDER_SCALE, "aria-valuemin": 1, "aria-valuenow": volumeLevel, max: VOLUME_SLIDER_SCALE, min: 1, onChange: _onVolumeChange, tabIndex: 0, type: 'range', value: volumeLevel }))));
};
export default VolumeSlider;
